<template>
  <v-dialog v-if="show" v-model="show" max-width="500" persistent>
    <v-card>
      <v-card-title class="headline">Reestablecer contraseña</v-card-title>
      <v-card-text>
        <v-text-field
          autofocus
          v-model="objetoResetPass.Usuario"
          label="Usuario"
          required
        ></v-text-field>
        <v-text-field v-model="objetoResetPass.Email" label="Email" required></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn style="width:50%" color="red darken-1" text @click="$emit('cierra-reset-password')">
          Cancelar
        </v-btn>
        <v-btn style="width:50%" color="green darken-1" text @click="pideResetPass()">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
      
    objetoResetPass: { Usuario: "", Email: "" }
  }),
  props: { show: Boolean },
  methods: {
    ...mapActions("passwordReset", ["updatePassworPaso1"]),
    async pideResetPass() {
      await this.updatePassworPaso1(this.objetoResetPass);
      this.$emit('cierra-reset-password');
    }
  }
};
</script>
